import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { RouteObserver } from 'src/app/shared/services/route-observer/route-observer.service';
import { UrlParamsState } from './url-params.state';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UrlParamsEffect {
  private readonly routeObserver = inject(RouteObserver);
  private readonly urlParamsState = inject(UrlParamsState);

  public registerUrlParamsTaskGroupIdChanges(): void {
    this.routeObserver.register({
      path: '/task-groups/:taskgroupid/tasks/:taskid',
      callback: (node: ActivatedRoute) => {
        node.params.pipe(take(1)).subscribe((params: Params) => {
          if (params['taskgroupid']) {
            this.urlParamsState.setActiveTaskGroupId(params['taskgroupid']);
            this.urlParamsState.setActiveTaskId(params['taskid']);
          } else {
            this.urlParamsState.setActiveTaskGroupId(null);
            this.urlParamsState.setActiveTaskId(null);
          }
        });
      },
    });
  }

  public registerUrlTopLevelTaskGroupsChanges(): void {
    this.routeObserver.register({
      path: '/task-groups',
      callback: (node: ActivatedRoute) => {
        node.params.pipe(take(1)).subscribe(() => {
          this.urlParamsState.setActiveTaskGroupId(null);
          this.urlParamsState.setActiveTaskId(null);
        });
      },
    });
  }
}
